import * as React from 'react';

import * as agui from 'arm-gui/dist/controls';
import AccountActions from '../../ui/account/account_actions';
import { connect } from 'react-redux';
import { Utils, isAuth, NumberFormatter, domain, domainVal, i18n, DateFormatter } from 'arm-common';

class ChangePassword extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[ChangePassword.jsx] ";
        this.changePasswordOnClick = this.changePasswordOnClick.bind(this);
        this.annullaOnClick = this.annullaOnClick.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.state = {
            validation: new Map(),
            oldPassword: "",
            newPassword: "",
            confirmPassword: ""
        }
    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');
        if (this.props.utente === null || this.props.utente === undefined) {
            this.props.history.push({ pathname: '/login' });
        }
    }

    inputChangeHandler(e, index) {
        console.log(this.componentName + ' handleChange id: ' + id + ' value: ' + value);
        let obj = {};
        let value = e.target.value;
        let id = e.target.id;
        obj[id] = value;
        this.setState(obj)
    }

    changePasswordOnClick() {
        console.log(this.componentName + 'changePasswordOnClick');

        if (!this.validateForm()) {
            console.log('validateForm return false');
            return;
        }

        this.props.changePassword(this.state.oldPassword, this.state.newPassword).then(
            resolve => {
                //    if (this.props.utente.datePasswordModified === null || this.props.utente.datePasswordModified === undefined) {
                this.props.history.push({ pathname: '/login' });
                //  } else {
                //    this.props.history.push({ pathname: '/account/manage' });
                //}
            },
            reject => {
                console.log("changePassword -> reject");
            }
        );
    }

    annullaOnClick() {
        console.log(this.componentName + 'annullaOnClick');
        this.props.history.goBack();
    }

    validateForm() {
        let validation = new Map();
        let required = ['oldPassword', 'newPassword', 'confirmPassword'];

        for (let i = 0; i < required.length; i++) {
            if (this.state[required[i]] === undefined || this.state[required[i]] === '' || this.state[required[i]] === null) {
                validation.set(required[i], 'valore obbligatorio');
            }
        }

        if (this.state['newPassword'] !== this.state['confirmPassword']) {
            validation.set('newPassword', 'Attenzione new password e confirm password non corrispondono');
            validation.set('confirmPassword', 'Attenzione new password e confirm password non corrispondono');
        }


        this.setState({ validation: validation });
        if (validation.size === 0) {
            return true;
        }
        return false;
    }


    render() {
        console.log(this.componentName + 'render');
        return (
            <div className="container justify-content-center mt-3" style={{ maxWidth: '500px' }}>
                <agui.aCardV4>
                    <agui.aCardV4Header >
                    <h3 className="panel-title">{i18n('ARM_CORE_QUEST.PASSWORD.CHANGE_PASSWORD', 'Modifica Password')}</h3>
                    </agui.aCardV4Header>
                    <form>
                        <agui.aCardV4Body>
                            <agui.ATextInputV4 id="oldPassword"
                                type="password"
                                value={this.state.oldPassword}
                                placeholder="Password corrente"
                                autocomplete="off"
                                required={true}
                                label={i18n('ARM_CORE_PRODUCT.PASSWORD.OLD_PASSWORD', 'Vecchia password')}
                                validation={this.state.validation}
                                onChange={this.inputChangeHandler} />

                            <agui.ATextInputV4 id="newPassword" type="password"
                                value={this.state.newPassword ? this.state.newPassword : ''}
                                autocomplete="off"
                                validation={this.state.validation}
                                placeholder="Digitare una nuova password"
                                required={true}
                                label={i18n('ARM_CORE_PRODUCT.PASSWORD.NEW_PASSWORD', 'Nuova password')}
                                onChange={this.inputChangeHandler} />


                            <agui.ATextInputV4 id="confirmPassword" type="password"
                                value={this.state.confirmPassword ? this.state.confirmPassword : ''}
                                autocomplete="off"
                                validation={this.state.validation}
                                placeholder="Digitare nuovamente la una nuova password"
                                required={true}
                                label={i18n('ARM_CORE_PRODUCT.PASSWORD.CONFIRM_PASSWORD', 'Conferma password')}
                                onChange={this.inputChangeHandler} />



                        </agui.aCardV4Body>

                        <div className="p-2">
                            <button type="button" className="btn btn-secondary float-right" onClick={this.annullaOnClick} >Annulla</button>

                            <button type="button" className="btn btn-primary" onClick={this.changePasswordOnClick} >Conferma</button>
                        </div>
                    </form>
                </agui.aCardV4>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        utente: state.account.utente
    }
}

function mapDispatchToProps(dispatch) {
    return {

        changePassword(oldPassword, newPassword) {
            return dispatch(AccountActions.changePassword(oldPassword, newPassword));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);